import React from 'react'

const InfoIcon = ({ size = 15, className, ...props }) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" className={className} width={size} height={size} viewBox="0 0 16.454 16.454">
      <g id="Icon_akar-info" data-name="Icon akar-info" transform="translate(-2.5 -2.5)">
        <path id="Path_5880" data-name="Path 5880" d="M18.454,10.727A7.727,7.727,0,1,1,10.727,3a7.727,7.727,0,0,1,7.727,7.727Z" fill="none" stroke="#8d8d8d" stroke-width="1" />
        <path id="Path_5881" data-name="Path 5881" d="M18,10.5h.008" transform="translate(-7.273 -3.636)" fill="none" stroke="#8d8d8d" stroke-linecap="round" stroke-width="1" />
        <path id="Path_5882" data-name="Path 5882" d="M15,16.5h1.545v3.864m-1.545,0h3.091" transform="translate(-5.818 -6.546)" fill="none" stroke="#8d8d8d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
      </g>
    </svg>

  )
}

export default InfoIcon
